// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pauseCadenceCard-module___card__container___5v1Yp {\n  margin-bottom: 15px;\n}\n", "",{"version":3,"sources":["webpack://./src/js/pages/userSettingsPages/cadenceSettings/pauseCadenceCard/pauseCadenceCard.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB","sourcesContent":["._card__container {\n  margin-bottom: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"_card__container": "pauseCadenceCard-module___card__container___5v1Yp"
};
export default ___CSS_LOADER_EXPORT___;
